import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = {
  id: "footer",
  class: "footer light-background"
}
const _hoisted_3 = { class: "container footer-top" }
const _hoisted_4 = { class: "row gy-4" }
const _hoisted_5 = { class: "col-lg-4 col-md-6 footer-about" }
const _hoisted_6 = { class: "footer-contact pt-3" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "col-lg-4 col-md-6 footer-links" }
const _hoisted_10 = { class: "col-lg-4 col-md-6 footer-links" }
const _hoisted_11 = { class: "container copyright text-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("footer", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[8] || (_cache[8] = _createElementVNode("a", { class: "logo d-flex align-items-center" }, [
              _createElementVNode("span", { class: "sitename" }, "MatrixHub Company Ltd.")
            ], -1)),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "footer-tagline" }, " Building modern digital experiences with strategy, design, and technology. ", -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "MatrixHub Company Ltd.", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("p", null, "Capital CityMall, Office #57", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("p", null, "P. O. Box 2763", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("p", null, "Dodoma, Tanzania", -1)),
              _createElementVNode("p", _hoisted_7, [
                _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Phone:", -1)),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("span", null, _toDisplayString(_ctx.phone), 1)
              ]),
              _createElementVNode("p", null, [
                _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Email:", -1)),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("a", {
                  href: 'mailto:' + _ctx.email,
                  class: "text-info"
                }, _toDisplayString(_ctx.email), 9, _hoisted_8)
              ])
            ]),
            _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"social-links d-flex mt-4\"><a href=\"https://x.com/matrixhubco\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"bi bi-twitter-x\"></i></a><a href=\"https://web.facebook.com/matrixhubco\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"bi bi-facebook\"></i></a><a href=\"https://www.instagram.com/matrixhubco/\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"bi bi-instagram\"></i></a><a href=\"https://tz.linkedin.com/company/matrixhubco\" target=\"_blank\" rel=\"noopener noreferrer\"><i class=\"bi bi-linkedin\"></i></a></div>", 1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[19] || (_cache[19] = _createElementVNode("h4", null, "Company", -1)),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("Home")
                  ])),
                  _: 1,
                  __: [11]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/about" }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("About us")
                  ])),
                  _: 1,
                  __: [12]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/how-we-work" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("How we Work!")
                  ])),
                  _: 1,
                  __: [13]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/who-we-serve" }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("Who We Serve")
                  ])),
                  _: 1,
                  __: [14]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/services" }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("Services")
                  ])),
                  _: 1,
                  __: [15]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/products" }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode("Products")
                  ])),
                  _: 1,
                  __: [16]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/team" }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("Team")
                  ])),
                  _: 1,
                  __: [17]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/contact" }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("Contact")
                  ])),
                  _: 1,
                  __: [18]
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[27] || (_cache[27] = _createElementVNode("h4", null, "Our Services", -1)),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/services" }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("Custom Web Development")
                  ])),
                  _: 1,
                  __: [20]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/services" }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode("Mobile App Solutions")
                  ])),
                  _: 1,
                  __: [21]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/services" }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode("UI/UX Design")
                  ])),
                  _: 1,
                  __: [22]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/services" }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode("Cybersecurity Solutions")
                  ])),
                  _: 1,
                  __: [23]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/services" }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode("Cloud Computing")
                  ])),
                  _: 1,
                  __: [24]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/services" }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createTextVNode("DevOps & Automation")
                  ])),
                  _: 1,
                  __: [25]
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/services" }, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createTextVNode("...and many more")
                  ])),
                  _: 1,
                  __: [26]
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", null, [
          _createTextVNode("© " + _toDisplayString(_ctx.currentYear) + " ", 1),
          _cache[28] || (_cache[28] = _createElementVNode("span", null, "MatrixHub Company Ltd.", -1)),
          _cache[29] || (_cache[29] = _createTextVNode(" All Rights Reserved."))
        ]),
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "credits" }, [
          _createTextVNode(" Designed by "),
          _createElementVNode("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            href: "https://matrixhub.co.tz/"
          }, "MatrixHub Company Ltd.")
        ], -1))
      ])
    ])
  ]))
}